import { useState, useEffect } from 'react';
import { getImageUrl } from './api';

let cachedLogoUrl = null;

export function useClubLogo() {
  const [logoUrl, setLogoUrl] = useState(cachedLogoUrl || '');

  useEffect(() => {
    if (cachedLogoUrl) {
      setLogoUrl(cachedLogoUrl);
      return;
    }
    const dbUrl = getImageUrl('/api/public/club-logo');
    const img = new Image();
    img.onload = () => {
      cachedLogoUrl = dbUrl;
      setLogoUrl(dbUrl);
    };
    img.onerror = () => {
      // DB hat kein Logo → Fallback
      cachedLogoUrl = '/devils-logo.png';
      setLogoUrl('/devils-logo.png');
    };
    img.src = dbUrl;
  }, []);

  return logoUrl;
}
